<div class="dialog">
  <div
    mat-dialog-title
    class="title"
  >
    REQUEST A CALLBACK
  </div>

  <ng-container *ngIf="isFormSubmitted">
    <div
      mat-dialog-content
      style="padding: 3rem"
    >
      <p>Interest successfully registered.</p>
    </div>

    <button
      mat-raised-button
      (click)="onClose()"
      class="dismiss"
    >
      Close
    </button>
  </ng-container>

  <ng-container *ngIf="!isFormSubmitted">
    <div
      mat-dialog-content
      *ngIf="!isFormSubmitted"
    >
      <form [formGroup]="interestForm">
        <app-text-input
          label="Name"
          placeholder="Name"
          [control]="$any(interestForm.get('name'))"
        />

        <app-mobile-number-input
          label="Mobile"
          placeholder="Mobile"
          [control]="$any(interestForm.get('mobile'))"
        />

        <app-text-input
          label="Company"
          placeholder="Company"
          [control]="$any(interestForm.get('company'))"
        />

        <app-checkbox-input
          [control]="$any(interestForm.get('interestGgbs'))"
          label="GGBS - EkoBlend"
        ></app-checkbox-input>

        <app-checkbox-input
          [control]="$any(interestForm.get('interestGfrp'))"
          label="GFRP - EkoBar"
        ></app-checkbox-input>

        <app-checkbox-input
          [control]="$any(interestForm.get('interestBitumen'))"
          label="Bitumen - TarShakti"
        ></app-checkbox-input>
      </form>
    </div>

    <div
      mat-dialog-actions
      class="action-buttons"
    >
      <button
        mat-raised-button
        (click)="onClose()"
        class="dismiss"
      >
        Cancel
      </button>

      <button
        mat-raised-button
        (click)="onSubmit()"
        class="dismiss"
        [disabled]="!interestForm.valid"
      >
        Submit
      </button>
    </div>
  </ng-container>
</div>
